import {
  Directive,
  input,
  InputSignal,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { Subject, debounceTime, filter, takeUntil } from 'rxjs';
import {
  CNPJValidation,
  CNPJ_SIZE,
} from '../constants/cnpj-validator.constants';

@Directive({
  selector: '[cnpjValidator]',
})
export class CnpjValidatorDirective implements OnInit, OnDestroy {
  formControlRef: InputSignal<FormControl> = input<FormControl>();

  destroySubject: Subject<boolean> = new Subject();

  constructor() {}

  ngOnDestroy(): void {
    this.destroySubject.next(true);
    this.destroySubject.complete();
  }

  ngOnInit(): void {
    this.formControlRef()
      .valueChanges.pipe(
        filter((value: string) => value?.length === CNPJ_SIZE),
        debounceTime(100),
        takeUntil(this.destroySubject)
      )
      .subscribe((value) => {
        const isValid = CNPJValidation(value);

        if (isValid) {
          this.formControlRef().setErrors(null, { emitEvent: false });
        } else {
          this.formControlRef().setErrors(
            {
              invalidCnpj: true,
            },
            { emitEvent: false }
          );
        }
      });
  }
}
